<template>
  <div class="pingan-trunk-big-policy-entry">
    <!-- 保单列表管理 -->
    <div class="content-area">
          <!-- 搜索工具栏 -->
          <div class="toolbar-container">
            <div class="search-section">
              <el-form :inline="true" :model="searchForm" class="search-form">
                <!-- 投保人搜索 -->
                <el-form-item label="投保人">
                  <el-input v-model="searchForm.policyholder" placeholder="投保人" style="width: 240px;"></el-input>
                </el-form-item>
                
                <!-- 保单号搜索 -->
                <el-form-item label="保单号">
                  <el-input v-model="searchForm.policyNo" placeholder="保单号" style="width: 200px;"></el-input>
                </el-form-item>
                
                <!-- 起保时间搜索 -->
                <el-form-item label="起保时间:">
                  <el-date-picker
                    v-model="searchForm.effectDateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 240px;">
                  </el-date-picker>
                </el-form-item>
                
                <!-- 创建时间搜索 -->
                <el-form-item label="创建时间:">
                  <el-date-picker
                    v-model="searchForm.createTimeRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 240px;">
                  </el-date-picker>
                </el-form-item>
                
                <!-- 订单状态搜索 -->
                <el-form-item label="订单状态">
                  <el-select v-model="searchForm.status" placeholder="订单状态" style="width: 100px;">
                    <el-option label="未知" :value="8"></el-option>
                    <el-option label="承保失败" :value="1"></el-option>
                    <el-option label="承保成功" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                
                <!-- 渠道搜索 -->
                <el-form-item label="渠道商:">
                  <el-autocomplete
                    v-model="searchForm.channel"
                    :fetch-suggestions="queryChannel"
                    placeholder="请输入渠道商"
                    @select="handleChannelSelect"
                    clearable
                    style="width: 200px;">
                    <template slot-scope="{ item }">
                      <div>{{ item.realname }} ({{ item.alias }})</div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                
                <el-form-item>
                  <el-button type="primary" @click="handleSearch">搜索</el-button>
                  <el-button @click="handleResetSearch">重置</el-button>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" icon="el-icon-plus" @click="handleAddPolicy">添加保单</el-button>
                  <el-button type="success" icon="el-icon-download" @click="handleExportExcel">导出Excel</el-button>
                </el-form-item>
              </el-form>
            </div>
            
          </div>

          <!-- 保单列表表格 -->
          <div class="table-container">
            <el-table
              :data="policyList"
              v-loading="loading"
              style="width: 100%"
              border
              stripe
              class="centered-table"
            >
              <el-table-column label="操作" width="500" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleViewPolicy(scope.row)">查看</el-button>
                  <el-button size="mini" type="warning" @click="handleInvoiceInfo(scope.row)">开票信息</el-button>
                  <!-- 根据老项目逻辑：如果没有投保单URL，显示获取投保单按钮 -->
                  <el-button 
                    v-if="!scope.row.proposal_url" 
                    size="mini" 
                    type="success" 
                    @click="handleGetProposal(scope.row)">
                    获取投保单
                  </el-button>
                  <!-- 如果有投保单URL但没有保单URL，显示获取电子保单按钮 -->
                  <el-button 
                    v-else-if="scope.row.proposal_url && !scope.row.policy_url" 
                    size="mini" 
                    type="success" 
                    @click="handleGetPolicy(scope.row)">
                    获取电子保单
                  </el-button>
                  <!-- 如果都有了，显示灰色不可点击的按钮 -->
                  <template v-else>
                    <el-button size="mini" disabled style="color: #adadad; cursor: not-allowed;">获取投保单</el-button>
                    <el-button size="mini" disabled style="color: #adadad; cursor: not-allowed;">获取电子保单</el-button>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="company_name" label="投保人" width="270" align="center"></el-table-column>
              <el-table-column prop="status" label="订单状态" width="120" align="center">
                <template slot-scope="scope">
                  <el-tag :type="getOrderStatusType(scope.row.status)">
                    {{ getOrderStatusText(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="proposal_no" label="投保单号" width="200" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.proposal_url" 
                        style="color: #409EFF; cursor: pointer;" 
                        @click="handleViewFile(scope.row.proposal_url)">
                    {{ scope.row.proposal_no }}
                  </span>
                  <span v-else style="color: #C0C4CC;">{{ scope.row.proposal_no || '未出单' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="proposal_stamp_url" label="投保单盖章件" width="120" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.proposal_stamp_url">
                    <el-image
                      v-for="(url, index) in parseImageUrls(scope.row.proposal_stamp_url)"
                      :key="index"
                      style="width: 30px; height: 30px; margin: 2px; cursor: pointer;"
                      :src="url"
                      :preview-src-list="parseImageUrls(scope.row.proposal_stamp_url)"
                      fit="cover"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="policy_no" label="保单号" width="200" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.policy_url" 
                        style="color: #409EFF; cursor: pointer;" 
                        @click="handleViewFile(scope.row.policy_url)">
                    {{ scope.row.policy_no }}
                  </span>
                  <span v-else style="color: #C0C4CC;">{{ scope.row.policy_no || '未出单' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="seq_no" label="渠道订单号" width="200" align="center"></el-table-column>
              <el-table-column prop="province" label="省份" width="80" align="center"></el-table-column>
              <el-table-column prop="city" label="城市" width="80" align="center"></el-table-column>
              <el-table-column prop="channel_name" label="渠道" width="150" align="center"></el-table-column>
              <el-table-column prop="created_at" label="创建时间" width="160" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.created_at) }}
                </template>
              </el-table-column>
              <el-table-column prop="effect_date" label="起保时间" width="160" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.effect_date) }}
                </template>
              </el-table-column>
              <el-table-column prop="expire_date" label="终保时间" width="160" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.expire_date) }}
                </template>
              </el-table-column>
              <el-table-column prop="license_file_url" label="营业执照" width="100" align="center">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.license_file_url" size="mini" type="text" @click="handleViewFile(scope.row.license_file_url)">查看</el-button>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="vat_invoice_type" label="开票类型" width="100" align="center">
                <template slot-scope="scope">
                  {{ getInvoiceTypeText(scope.row.vat_invoice_type) }}
                </template>
              </el-table-column>
              <el-table-column prop="company_name" label="纳税人名称" width="250" align="center"></el-table-column>
              <el-table-column prop="license_no" label="税务登记号" width="250" align="center"></el-table-column>
              <el-table-column prop="tax_address" label="税务登记地址" width="200" align="center"></el-table-column>
              <el-table-column prop="tax_mobile" label="税务登记联系电话" width="150" align="center"></el-table-column>
              <el-table-column prop="tax_bank" label="税务开户银行名称" width="200" align="center"></el-table-column>
              <el-table-column prop="tax_bank_no" label="税务开户银行账号" width="200" align="center"></el-table-column>
            </el-table>
          </div>

          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>

    <!-- 保单操作对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addPolicyDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleCloseAddPolicyDialog">
      
      <el-form
        ref="addPolicyForm"
        :model="addPolicyForm"
        :rules="addPolicyRules"
        label-width="120px"
        class="add-policy-form">
        
        <!-- 投保人信息 -->
        <div class="form-section">
          <h4 class="section-title">投保人信息</h4>
          
          <el-form-item label="公司名称" prop="company_name">
            <el-input
              v-model="addPolicyForm.company_name"
              placeholder="请输入公司名称"
              @blur="handleCompanyNameBlur"
              :disabled="isViewMode"
              style="width: 300px;">
            </el-input>
          </el-form-item>
          
          <el-form-item label="证件号码" prop="license_no">
            <el-input
              v-model="addPolicyForm.license_no"
              placeholder="请输入证件号码"
              :disabled="isViewMode"
              style="width: 300px;">
            </el-input>
          </el-form-item>
          
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="addPolicyForm.address"
              placeholder="请输入地址"
              :disabled="isViewMode"
              style="width: 500px;">
            </el-input>
          </el-form-item>
          
          <el-form-item label="营业执照" prop="license_file_url">
            <el-upload
              v-if="!isViewMode"
              ref="licenseUpload"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleLicenseUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              name="fileVal"
              accept=".pdf,.jpg,.png,.jpeg,.doc,.docx">
              <el-button size="small" type="primary">上传营业执照</el-button>
            </el-upload>
            <div v-if="addPolicyForm.license_file_url" class="upload-preview">
              <el-image
                v-if="isImageFile(addPolicyForm.license_file_url)"
                :src="addPolicyForm.license_file_url"
                style="width: 100px; height: 100px;"
                fit="cover">
              </el-image>
              <div v-else class="file-preview">
                <i class="el-icon-document"></i>
                <span>{{ getFileName(addPolicyForm.license_file_url) }}</span>
              </div>
              <el-button
                v-if="!isViewMode"
                type="text"
                size="small"
                @click="addPolicyForm.license_file_url = ''"
                class="delete-btn">
                删除
              </el-button>
            </div>
          </el-form-item>
        </div>
        
        <!-- 投保信息 -->
        <div class="form-section">
          <h4 class="section-title">投保信息</h4>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="起保日期" prop="effect_date">
                <el-date-picker
                  v-model="addPolicyForm.effect_date"
                  type="datetime"
                  placeholder="选择起保日期"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startDatePickerOptions"
                  :disabled="isViewMode"
                  @change="handleStartDateChange"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终保日期" prop="expire_date">
                <el-date-picker
                  v-model="addPolicyForm.expire_date"
                  type="datetime"
                  placeholder="选择终保日期"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="endDatePickerOptions"
                  :disabled="isViewMode"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="渠道商" prop="channel_id">
            <el-autocomplete
              v-model="addPolicyForm.channel_name"
              :fetch-suggestions="queryChannelForAdd"
              placeholder="请输入渠道商"
              @select="handleAddChannelSelect"
              :disabled="isViewMode"
              clearable
              style="width: 300px;">
              <template slot-scope="{ item }">
                <div>{{ item.realname }} ({{ item.alias }})</div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </div>
        
        <!-- 附件信息 -->
        <div class="form-section">
          <h4 class="section-title">附件信息</h4>
          
          <el-form-item label="支付凭证">
            <el-upload
              v-if="!isViewMode"
              ref="payVoucherUpload"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handlePayVoucherUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              name="fileVal"
              accept=".pdf,.jpg,.png,.jpeg,.doc,.docx"
              multiple>
              <el-button size="small" type="primary">上传支付凭证</el-button>
            </el-upload>
            <div v-if="addPolicyForm.pay_voucher_url.length > 0" class="upload-list">
              <div
                v-for="(file, index) in addPolicyForm.pay_voucher_url"
                :key="index"
                class="upload-item">
                <el-image
                  v-if="isImageFile(file)"
                  :src="file"
                  style="width: 80px; height: 80px;"
                  fit="cover">
                </el-image>
                <div v-else class="file-preview small">
                  <i class="el-icon-document"></i>
                  <span>{{ getFileName(file) }}</span>
                </div>
                <el-button
                  v-if="!isViewMode"
                  type="text"
                  size="small"
                  @click="removePayVoucher(index)"
                  class="delete-btn">
                  删除
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddPolicyDialog">{{ isViewMode ? '关闭' : '取消' }}</el-button>
        <el-button
          v-if="!isViewMode"
          type="primary"
          @click="handleSavePolicy"
          :loading="saveLoading">
          {{ saveLoading ? '保存中' : '保存' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 开票信息对话框 -->
    <el-dialog
      title="开票信息"
      :visible.sync="showInvoiceDialog"
      width="600px"
      :close-on-click-modal="false">
      <PingAnTrunkInvoiceInfo
        v-if="showInvoiceDialog"
        :policy-id="currentInvoiceId"
        @close="showInvoiceDialog = false"
        @success="handleInvoiceSuccess" />
    </el-dialog>

    <!-- 保单上传对话框 -->
    <el-dialog
      :title="currentPolicyType === 1 ? '上传投保单' : '上传电子保单'"
      :visible.sync="showPolicyDialog"
      width="600px"
      :close-on-click-modal="false">
      <PingAnTrunkPolicyUpload
        v-if="showPolicyDialog"
        :id="currentPolicyId"
        :policy-type="currentPolicyType"
        @close="showPolicyDialog = false"
        @success="handlePolicyUploadSuccess" />
    </el-dialog>

  </div>
</template>

<script>
import {
  getPingAnTrunkOrderList,
  getPingAnTrunkOrderInfo,
  deletePingAnTrunkOrder,
  updatePingAnTrunkOrder,
  exportPingAnTrunkOrderExcel,
  savePingAnTrunkOrder,
  uploadPingAnTrunkPolicyFile
} from '@/api/gxborder'
import { getChannelList } from '@/api/member'
import PingAnTrunkInvoiceInfo from './PingAnTrunkInvoiceInfo.vue'
import PingAnTrunkPolicyUpload from './PingAnTrunkPolicyUpload.vue'

export default {
  name: 'PingAnTrunkBigPolicyEntry',
  components: {
    PingAnTrunkInvoiceInfo,
    PingAnTrunkPolicyUpload
  },
  data() {
    return {
      // 保单列表相关
      policyList: [],
      loading: false,
      totalAmount: '0.00',
      
      // 搜索表单
      searchForm: {
        policyholder: '',
        policyNo: '',
        effectDateRange: [],
        createTimeRange: [],
        status: '',
        channel: '',
        selectedChannel: null
      },
      
      // 渠道列表
      channelList: [],
      
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },

      // 保单对话框相关
      addPolicyDialogVisible: false,
      dialogMode: 'add', // add, view, edit
      currentPolicyId: null,
      saveLoading: false,
      addPolicyForm: {
        company_name: '',
        license_no: '',
        address: '',
        license_file_url: '',
        effect_date: '',
        expire_date: '',
        channel_id: null,
        channel_name: '',
        pay_voucher_url: []
      },
      addPolicyRules: {
        company_name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        license_no: [
          { required: true, message: '请输入证件号码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        license_file_url: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ],
        effect_date: [
          { required: true, message: '请选择起保日期', trigger: 'change' }
        ],
        expire_date: [
          { required: true, message: '请选择终保日期', trigger: 'change' }
        ],
        channel_id: [
          { required: true, message: '请选择渠道商', trigger: 'change' }
        ]
      },
      
      // 上传相关
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + this.$store.getters.token,
        'AppKey': 'BpLnfgDs'
      },
      
      // 日期选择器配置
      startDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 不能选择今天之前的日期
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.addPolicyForm.effect_date) {
            return time.getTime() <= new Date(this.addPolicyForm.effect_date).getTime()
          }
          return time.getTime() < Date.now() - 8.64e7
        }
      },

      // 开票信息对话框相关
      showInvoiceDialog: false,
      currentInvoiceId: null,

      // 保单上传对话框相关
      showPolicyDialog: false,
      currentPolicyId: null,
      currentPolicyType: 1 // 1表示投保单，2表示电子保单

    }
  },
  computed: {
    // 对话框标题
    dialogTitle() {
      switch (this.dialogMode) {
        case 'view':
          return '查看保单'
        case 'edit':
          return '编辑保单'
        case 'add':
        default:
          return '添加保单'
      }
    },
    // 是否为查看模式
    isViewMode() {
      return this.dialogMode === 'view'
    }
  },
  mounted() {
    this.fetchPolicyList()
    this.fetchChannelList()
  },
  methods: {
    // ==================== 标签页切换 ====================
    handleTabClick(tab) {
      if (tab.name === 'list') {
        this.fetchPolicyList()
      } else if (tab.name === 'upload') {
        this.loadHistoryData()
      }
    },

    // ==================== 保单列表管理 ====================
    // 获取保单列表
    async fetchPolicyList() {
      this.loading = true
      try {
        const params = this.buildSearchParams()
        const response = await getPingAnTrunkOrderList(params)
        
        if (response && response.rows) {
          this.policyList = response.rows || []
          this.pagination.total = response.total || 0
          // 计算总金额（老项目中的sum字段，单位为分）
          this.totalAmount = response.sum ? (response.sum / 100).toFixed(2) : '0.00'
        } else {
          this.policyList = []
          this.pagination.total = 0
          this.totalAmount = '0.00'
          this.$message.error('获取保单列表失败')
        }
      } catch (error) {
        this.policyList = []
        this.pagination.total = 0
        this.totalAmount = '0.00'
        this.$message.error('获取保单列表失败')
        console.error('获取保单列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 构建搜索参数
    buildSearchParams() {
      const params = {
        page: this.pagination.currentPage,
        rows: this.pagination.pageSize
      }

      if (this.searchForm.policyholder) params.policyholder = this.searchForm.policyholder
      if (this.searchForm.policyNo) params.policy_no = this.searchForm.policyNo
      if (this.searchForm.effectDateRange && this.searchForm.effectDateRange.length === 2) {
        params.begin_date = Date.parse(new Date(this.searchForm.effectDateRange[0] + ' 00:00:00').toISOString()) / 1000
        params.end_date = Date.parse(new Date(this.searchForm.effectDateRange[1] + ' 23:59:59').toISOString()) / 1000
      }
      if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
        params.begin_created = Date.parse(new Date(this.searchForm.createTimeRange[0] + ' 00:00:00').toISOString()) / 1000
        params.end_created = Date.parse(new Date(this.searchForm.createTimeRange[1] + ' 23:59:59').toISOString()) / 1000
      }
      if (this.searchForm.status !== '') params.status = this.searchForm.status

      // 渠道搜索
      if (this.searchForm.selectedChannel) {
        params.channel_id = this.searchForm.selectedChannel.id
      }

      return params
    },

    // 重置搜索表单
    resetSearchForm() {
      this.searchForm.policyholder = ''
      this.searchForm.policyNo = ''
      this.searchForm.effectDateRange = []
      this.searchForm.createTimeRange = []
      this.searchForm.status = ''
      this.searchForm.channel = ''
      this.searchForm.selectedChannel = null
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchPolicyList()
    },

    // 重置搜索
    handleResetSearch() {
      this.resetSearchForm()
      this.pagination.currentPage = 1
      this.fetchPolicyList()
    },

    // ==================== 渠道管理 ====================
    // 获取渠道列表
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },

    // 渠道搜索
    queryChannel(queryString, callback) {
      if (!queryString) {
        callback([])
        return
      }
      
      const results = this.channelList.filter(channel => {
        return (channel.realname && channel.realname.toLowerCase().includes(queryString.toLowerCase())) ||
               (channel.alias && channel.alias.toLowerCase().includes(queryString.toLowerCase()))
      })
      callback(results)
    },

    // 选择渠道
    handleChannelSelect(item) {
      this.searchForm.selectedChannel = item
    },

    // ==================== 保单操作 ====================
    // 查看保单详情
    async handleViewPolicy(row) {
      try {
        // 设置对话框模式为查看
        this.dialogMode = 'view'
        this.currentPolicyId = row.id
        
        // 加载保单详情数据
        await this.loadPolicyDetail(row.id)
        
        // 显示对话框
        this.addPolicyDialogVisible = true
      } catch (error) {
        console.error('加载保单详情失败:', error)
        this.$message.error('加载保单详情失败')
      }
    },

    // 加载保单详情
    async loadPolicyDetail(id) {
      try {
        const response = await getPingAnTrunkOrderInfo({ id })
        
        if (response && response.err_code === 0 && response.data) {
          const data = response.data
          
          // 处理支付凭证URL数据
          const payVoucherUrls = this.parseUrlsWithEscape(data.pay_voucher_url)

          // 将数据填充到表单中
          this.addPolicyForm = {
            company_name: data.company_name || '',
            license_no: data.license_no || '',
            address: data.address || '',
            effect_date: data.effect_date || '',
            expire_date: data.expire_date || '',
            channel_id: data.channel_id || '',
            channel_name: data.channel_name || '',
            license_file_url: data.license_file_url || '',
            pay_voucher_url: payVoucherUrls
          }
        } else {
          throw new Error(response.err_msg || '获取保单详情失败')
        }
      } catch (error) {
        console.error('加载保单详情失败:', error)
        throw error
      }
    },

    // 编辑保单
    async handleEditPolicy(row) {
      try {
        // 设置对话框模式为编辑
        this.dialogMode = 'edit'
        this.currentPolicyId = row.id
        
        // 加载保单详情数据
        await this.loadPolicyDetail(row.id)
        
        // 显示对话框
        this.addPolicyDialogVisible = true
      } catch (error) {
        console.error('加载保单详情失败:', error)
        this.$message.error('加载保单详情失败')
      }
    },

    // 开票信息
    handleInvoiceInfo(row) {
      // 打开开票信息对话框
      this.showInvoiceDialog = true
      this.currentInvoiceId = row.id
    },

    // 获取投保单
    handleGetProposal(row) {
      // 打开投保单上传对话框
      this.showPolicyDialog = true
      this.currentPolicyId = row.id
      this.currentPolicyType = 1 // 1表示投保单
    },

    // 获取电子保单
    handleGetPolicy(row) {
      // 打开电子保单上传对话框
      this.showPolicyDialog = true
      this.currentPolicyId = row.id
      this.currentPolicyType = 2 // 2表示电子保单
    },

    // 查看文件
    handleViewFile(url) {
      window.open(url, '_blank')
    },

    // 解析图片URL
    parseImageUrls(urlString) {
      if (!urlString) {
        return []
      }

      try {
        // 尝试解析JSON格式的字符串
        if (typeof urlString === 'string' && (urlString.startsWith('[') || urlString.startsWith('["'))) {
          const parsed = JSON.parse(urlString)
          if (Array.isArray(parsed)) {
            return parsed.filter(url => url && typeof url === 'string').map(url => url.trim())
          }
        }
        
        // 如果不是JSON格式，尝试其他分隔符
        if (typeof urlString === 'string') {
          // 尝试按逗号分割
          let imageUrls = urlString.split(',').map(url => url.trim()).filter(url => url)
          
          // 如果没有逗号，可能是分号或其他分隔符
          if (imageUrls.length === 1) {
            imageUrls = urlString.split(';').map(url => url.trim()).filter(url => url)
          }
          
          return imageUrls
        }
        
        // 如果是数组直接返回
        if (Array.isArray(urlString)) {
          return urlString.filter(url => url && typeof url === 'string')
        }
        
        // 其他情况返回单个URL
        return [urlString]
      } catch (error) {
        console.error('解析图片URL失败:', error)
        // 解析失败时，尝试作为普通字符串处理
        return typeof urlString === 'string' ? [urlString] : []
      }
    },

    // 解析包含转义字符的URL数据
    parseUrlsWithEscape(urlData) {
      if (!urlData) {
        return []
      }

      try {
        if (typeof urlData === 'string') {
          // 如果是字符串，尝试解析JSON
          if (urlData.startsWith('[') && urlData.endsWith(']')) {
            const parsed = JSON.parse(urlData)
            if (Array.isArray(parsed)) {
              return parsed.map(url => {
                // 处理包含转义字符和反引号的URL
                if (typeof url === 'string') {
                  return url.replace(/\\"/g, '"').replace(/`/g, '').trim()
                }
                return url
              }).filter(url => url)
            }
          } else {
            // 单个URL字符串
            return [urlData.replace(/\\"/g, '"').replace(/`/g, '').trim()].filter(url => url)
          }
        } else if (Array.isArray(urlData)) {
          // 如果已经是数组
          return urlData.map(url => {
            if (typeof url === 'string') {
              return url.replace(/\\"/g, '"').replace(/`/g, '').trim()
            }
            return url
          }).filter(url => url)
        }
        
        return []
      } catch (error) {
        console.warn('解析URL数据失败:', error)
        return []
      }
    },

    // 添加保单
    handleAddPolicy() {
      this.dialogMode = 'add'
      this.currentPolicyId = null
      this.addPolicyDialogVisible = true
      this.resetAddPolicyForm()
    },

    // 重置添加保单表单
    resetAddPolicyForm() {
      this.addPolicyForm = {
        company_name: '',
        license_no: '',
        address: '',
        license_file_url: '',
        effect_date: '',
        expire_date: '',
        channel_id: null,
        channel_name: '',
        pay_voucher_url: []
      }
      // 重置对话框状态
      this.dialogMode = 'add'
      this.currentPolicyId = null
      this.$nextTick(() => {
        if (this.$refs.addPolicyForm) {
          this.$refs.addPolicyForm.clearValidate()
        }
      })
    },

    // 关闭添加保单对话框
    handleCloseAddPolicyDialog() {
      this.addPolicyDialogVisible = false
      this.resetAddPolicyForm()
    },

    // 公司名称失焦事件 - 自动获取公司信息
    async handleCompanyNameBlur() {
      if (!this.addPolicyForm.company_name.trim()) {
        return
      }
      
      try {
        // 调用API获取公司信息
        const response = await this.$http.get('/v1/admin/cmn/get/company/address', {
          params: { name: this.addPolicyForm.company_name }
        })
        
        if (response.data.err_code === 0 && response.data.data) {
          const companyData = response.data.data
          // 自动填充公司信息
          this.addPolicyForm.license_no = companyData.license_no || ''
          this.addPolicyForm.address = companyData.tax_address || companyData.address || ''
          if (companyData.license_file_url) {
            this.addPolicyForm.license_file_url = companyData.license_file_url
          }
        }
      } catch (error) {
        console.log('获取公司信息失败:', error)
      }
    },

    // 起保日期变化事件
    handleStartDateChange(value) {
      if (value) {
        // 自动设置终保日期为一年后
        const startDate = new Date(value)
        const endDate = new Date(startDate.getFullYear() + 1, startDate.getMonth(), startDate.getDate() - 1, 23, 59, 59)
        this.addPolicyForm.expire_date = this.formatDateTime(endDate)
      }
    },

    // 格式化日期时间
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 渠道商查询（用于添加保单）
    queryChannelForAdd(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            return item.realname.toLowerCase().includes(queryString.toLowerCase()) ||
                   item.alias.toLowerCase().includes(queryString.toLowerCase())
          })
        : this.channelList
      cb(results)
    },

    // 选择渠道商（用于添加保单）
    handleAddChannelSelect(item) {
      this.addPolicyForm.channel_id = item.id
      this.addPolicyForm.channel_name = item.realname
    },

    // 文件上传前验证
    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传 JPG/PNG/PDF/DOC/DOCX 格式的文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      return true
    },

    // 营业执照上传成功
    handleLicenseUploadSuccess(response) {
      if (response.err_code === 0) {
        this.addPolicyForm.license_file_url = response.data
        this.$message.success('营业执照上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 支付凭证上传成功
    handlePayVoucherUploadSuccess(response) {
      if (response.err_code === 0) {
        this.addPolicyForm.pay_voucher_url.push(response.data)
        this.$message.success('支付凭证上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败
    handleUploadError() {
      this.$message.error('文件上传失败，请重试')
    },

    // 删除支付凭证
    removePayVoucher(index) {
      this.addPolicyForm.pay_voucher_url.splice(index, 1)
    },

    // 判断是否为图片文件
    isImageFile(url) {
      if (!url) return false
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      const lowerUrl = url.toLowerCase()
      return imageExtensions.some(ext => lowerUrl.includes(ext))
    },

    // 获取文件名
    getFileName(url) {
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },

    // 保存保单
    async handleSavePolicy() {
      // 表单验证
      try {
        await this.$refs.addPolicyForm.validate()
      } catch (error) {
        this.$message.error('请完善表单信息')
        return
      }

      // 检查必填项
      if (!this.addPolicyForm.company_name) {
        this.$message.error('请输入公司名称')
        return
      }
      if (!this.addPolicyForm.license_no) {
        this.$message.error('请输入营业执照号')
        return
      }
      if (!this.addPolicyForm.address) {
        this.$message.error('请输入公司地址')
        return
      }
      if (!this.addPolicyForm.effect_date) {
        this.$message.error('请选择起保时间')
        return
      }
      if (!this.addPolicyForm.expire_date) {
        this.$message.error('请选择终保时间')
        return
      }
      if (!this.addPolicyForm.channel_id) {
        this.$message.error('请选择渠道商')
        return
      }

      // 检查时间逻辑
      if (new Date(this.addPolicyForm.effect_date) >= new Date(this.addPolicyForm.expire_date)) {
        this.$message.error('终保时间不可以在起保时间之前')
        return
      }

      this.saveLoading = true
      try {
        // 准备提交数据
        const submitData = {
          channel_id: this.addPolicyForm.channel_id,
          company_name: this.addPolicyForm.company_name,
          license_no: this.addPolicyForm.license_no,
          address: this.addPolicyForm.address,
          effect_date: Math.floor(new Date(this.addPolicyForm.effect_date).getTime() / 1000),
          expire_date: Math.floor(new Date(this.addPolicyForm.expire_date).getTime() / 1000),
          license_file_url: this.addPolicyForm.license_file_url || '',
          pay_voucher_url: this.addPolicyForm.pay_voucher_url || []
        }

        // 如果是编辑模式，添加ID参数
        if (this.dialogMode === 'edit' && this.currentPolicyId) {
          submitData.id = this.currentPolicyId
        }

        // 根据模式调用不同的API
        let response
        if (this.dialogMode === 'edit') {
          response = await updatePingAnTrunkOrder(submitData)
        } else {
          response = await savePingAnTrunkOrder(submitData)
        }
        
        if (response.err_code === 0) {
          const successMessage = this.dialogMode === 'edit' ? '保单修改成功' : '保单添加成功'
          this.$message.success(successMessage)
          this.addPolicyDialogVisible = false
          this.resetAddPolicyForm()
          // 刷新列表
          this.fetchPolicyList()
        } else {
          const errorMessage = this.dialogMode === 'edit' ? '保单修改失败' : '保单添加失败'
          this.$message.error(response.err_msg || errorMessage)
        }
      } catch (error) {
        console.error('保存保单失败:', error)
        this.$message.error('保存失败: ' + (error.message || '网络错误'))
      } finally {
        this.saveLoading = false
      }
    },

    // 导出Excel
    async handleExportExcel() {
      try {
        this.$message.info('正在导出Excel，请稍候...')
        const params = this.buildSearchParams()
        // 移除分页参数，获取所有数据
        delete params.page
        delete params.rows
        
        const response = await getPingAnTrunkOrderList(params)
        
        if (response && response.rows && response.rows.length > 0) {
          // 处理数据格式
          const excelData = response.rows.map(row => ({
            '投保人': row.company_name || '',
            '保单号': row.policy_no || '',
            '渠道订单号': row.seq_no || '',
            '省份': row.province || '',
            '城市': row.city || '',
            '渠道': row.channel_name || '',
            '创建时间': this.formatDateTime(row.created_at),
            '起保时间': this.formatDateTime(row.effect_date),
            '终保时间': this.formatDateTime(row.expire_date),
            '开票类型': this.getInvoiceTypeText(row.vat_invoice_type),
            '税务登记地址': row.tax_address || '',
            '税务开户银行名称': row.tax_bank || '',
            '税务开户银行账号': row.tax_bank_no || '',
            '税务登记联系电话': row.tax_mobile || '',
            '纳税人名称': row.company_name || '',
            '税务登记号': row.license_no || ''
          }))
          
          // 使用第三方库导出Excel（需要安装 xlsx 库）
          import('xlsx').then(XLSX => {
            const ws = XLSX.utils.json_to_sheet(excelData)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
            XLSX.writeFile(wb, `平安大保单录入订单_${this.formatDate(new Date())}.xlsx`)
            this.$message.success('Excel导出成功')
          }).catch(() => {
            this.$message.error('Excel导出功能需要安装相关依赖')
          })
        } else {
          this.$message.warning('没有数据可导出')
        }
      } catch (error) {
        this.$message.error('Excel导出失败')
        console.error('Excel导出失败:', error)
      }
    },

    // ==================== 状态管理 ====================
    // 获取订单状态类型
    getOrderStatusType(status) {
      const statusMap = {
        1: 'danger',  // 承保失败
        2: 'success', // 承保成功
        8: 'warning'  // 未知
      }
      return statusMap[status] || 'info'
    },

    // 获取订单状态文本
    getOrderStatusText(status) {
      const statusMap = {
        1: '承保失败',
        2: '承保成功',
        8: '未知'
      }
      return statusMap[status] || '未知'
    },

    // 获取开票类型文本
    getInvoiceTypeText(type) {
      const typeMap = {
        1: '普通发票',
        2: '专用发票'
      }
      return typeMap[type] || '-'
    },

    // ==================== 分页 ====================
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchPolicyList()
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchPolicyList()
    },

    // ==================== 工具方法 ====================
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      if (date.getFullYear() === 1) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 格式化日期时间
     formatDateTime(date) {
       if (!date) return ''
       const d = new Date(date)
       const year = d.getFullYear()
       const month = String(d.getMonth() + 1).padStart(2, '0')
       const day = String(d.getDate()).padStart(2, '0')
       const hours = String(d.getHours()).padStart(2, '0')
       const minutes = String(d.getMinutes()).padStart(2, '0')
       const seconds = String(d.getSeconds()).padStart(2, '0')
       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
     },

     // 获取开票类型文本
     getInvoiceTypeText(type) {
       const typeMap = {
         1: '个人',
         2: '企业',
         3: '不开票'
       }
       return typeMap[type] || '未知'
     },

     // 处理开票信息保存成功
     handleInvoiceSuccess() {
       this.$message.success('开票信息保存成功')
       this.showInvoiceDialog = false
       this.fetchPolicyList() // 刷新列表
     },

     // 处理保单上传成功
     handlePolicyUploadSuccess() {
       const message = this.currentPolicyType === 1 ? '投保单上传成功' : '电子保单上传成功'
       this.$message.success(message)
       this.showPolicyDialog = false
       this.fetchPolicyList() // 刷新列表
     }
  }
}
</script>

<style lang="less" scoped>
.pingan-trunk-big-policy-entry {
  padding: 20px;
  
  .page-header {
    margin-bottom: 20px;
    h2 {
      margin: 0 0 8px 0;
      color: #303133;
    }
    p {
      margin: 0;
      color: #909399;
      font-size: 14px;
    }
  }

  // 工具栏样式
  .toolbar-container {
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .search-section {
      margin-bottom: 15px;
      
      .search-form {
        margin-bottom: 0;
        
        .el-form-item {
          margin-bottom: 10px;
          margin-right: 15px;
        }
      }
    }
    
    .action-section {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  }

  // 表格容器样式
  .table-container {
    padding: 0 20px;
    margin-bottom: 20px;
  }

  // 分页样式
  .pagination-container {
    padding: 20px;
    text-align: right;
    border-top: 1px solid #ebeef5;
  }

  // 内容区域样式
  .content-area {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  // 批量上传样式
  .upload-section {
    margin-bottom: 30px;
    
    .upload-demo {
      text-align: center;
    }
  }

  .preview-section {
    margin-bottom: 30px;
    h3 {
      margin-bottom: 15px;
      color: #303133;
      font-size: 16px;
    }
  }

  .action-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
    
    .statistics {
      display: flex;
      align-items: center;
      margin-top: 15px;
      font-size: 14px;
      color: #606266;
      
      span {
        margin-right: 15px;
      }
    }
  }

  .history-section {
    h3 {
      margin-bottom: 15px;
      color: #303133;
      font-size: 16px;
    }
  }

  // 标签页样式
  .el-tabs {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .el-tabs__content {
      padding: 0;
    }
    
    .el-tab-pane {
      min-height: 500px;
    }
  }

  // 表格样式优化
  .el-table {
    margin-bottom: 20px;
    
    .el-button--mini {
      margin-right: 5px;
      margin-bottom: 2px;
    }
  }

  // 状态标签样式
  .el-tag {
    margin-right: 5px;
  }

  // 链接样式
  .table-link {
    color: #409EFF;
    cursor: pointer;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  // 上传提示样式
  .el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
  }

  // 响应式设计
  @media (max-width: 768px) {
    padding: 15px;
    
    .toolbar-container {
      padding: 15px;
      
      .search-section .search-form .el-form-item {
        margin-right: 10px;
      }
      
      .action-section {
        flex-direction: column;
        gap: 10px;
      }
    }
    
    .table-container {
      padding: 0 10px;
    }
    
    .pagination-container {
      padding: 15px 10px;
      text-align: center;
    }
  }
}

// 表格居中样式
.centered-table {
  .el-table__header-wrapper {
    th {
      text-align: center !important;
    }
  }
  
  .el-table__body-wrapper {
    td {
      text-align: center !important;
    }
  }
  
  // 确保表格内容垂直居中
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
  }
  
  // 操作按钮居中
  .table-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    
    .el-button {
      margin: 0;
    }
  }
}

/* 图片预览样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}

/* 添加保单表单样式 */
.form-section {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.section-title {
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #409EFF;
  color: #409EFF;
  font-size: 16px;
  font-weight: bold;
}

.add-policy-form .el-form-item {
  margin-bottom: 20px;
}

.upload-preview {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-preview {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.file-preview.small {
  padding: 3px 8px;
  font-size: 12px;
}

.delete-btn {
  color: #f56c6c;
}

.upload-list {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}
</style>

<style>
/* 全局样式，用于美化iframe对话框 */
.policy-detail-dialog .el-message-box {
  width: 80% !important;
  max-width: 1000px !important;
}

.policy-detail-dialog .el-message-box__content {
  padding: 0 !important;
}

.policy-detail-dialog .el-message-box__message {
  margin: 0 !important;
}

.invoice-info-dialog .el-message-box {
  width: 500px !important;
}

.invoice-info-dialog .el-message-box__content {
  padding: 0 !important;
}

.invoice-info-dialog .el-message-box__message {
  margin: 0 !important;
}
</style>
